import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { useFlags } from "@/utils/launchDarkly";

import { initializePunchPassesAtom } from "../atoms/actions/initializePunchPassesAtom/initializePunchPassesAtom";
import { useInitializePunchPassesFromBooking$key } from "./__generated__/useInitializePunchPassesFromBooking.graphql";

export const useInitializePunchPassesFromBooking = ({
  fragmentRef,
}: {
  fragmentRef: useInitializePunchPassesFromBooking$key | undefined;
}) => {
  const data = useFragment(
    useInitializePunchPassesFromBookingFragmentString,
    fragmentRef
  );
  const { patronPunchPassesEnabled } = useFlags();

  const initializePunchPasses = useSetAtom(initializePunchPassesAtom);

  useEffect(() => {
    if (!patronPunchPassesEnabled) {
      initializePunchPasses({ data: null });
      return;
    }
    initializePunchPasses({ data: data ?? null });
  }, [data, initializePunchPasses, patronPunchPassesEnabled]);
};

const useInitializePunchPassesFromBookingFragmentString = graphql`
  fragment useInitializePunchPassesFromBooking on Booking {
    id
    ownerClient {
      ... on Customer {
        id
      }
      ... on Member {
        id
      }
    }
    orders {
      edges {
        node {
          id
          lineItemGroups {
            id
            type
            round {
              id
              player {
                id
              }
            }
            punchPass {
              id
              remainingPunchCount
              client {
                ... on Customer {
                  id
                  fullName
                }
              }
              punchPassTemplate {
                name
                calculationType
                type
              }
            }
            punchPassesSelfValid: punchPassOptions(
              appliesTo: SELF
              valid: true
            ) {
              id
              remainingPunchCount
              client {
                ... on Customer {
                  id
                  fullName
                }
              }
              punchPassTemplate {
                name
                calculationType
                type
              }
            }
            punchPassesOthersValid: punchPassOptions(
              appliesTo: OTHERS
              valid: true
            ) {
              id
              remainingPunchCount
              client {
                ... on Customer {
                  id
                  fullName
                }
              }
              punchPassTemplate {
                name
                calculationType
                type
              }
            }
            punchPassesSelfInvalid: punchPassOptions(
              appliesTo: SELF
              valid: false
            ) {
              id
              remainingPunchCount
              client {
                ... on Customer {
                  id
                  fullName
                }
              }
              punchPassTemplate {
                name
                calculationType
                type
              }
            }
          }
        }
      }
    }
  }
`;
